/**
 * @generated SignedSource<<d261ab4b0f3431de0019b1cc082935de>>
 * @relayHash d5e3286223a91d87f6009c2bb59bd978
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c5284df5c1357b767ad09faf79381394cc3bd7bbb22e019ce9b51a09cde13a0b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c5284df5c1357b767ad09faf79381394cc3bd7bbb22e019ce9b51a09cde13a0b",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
